import React, {useEffect} from 'react';
import {useEditAdminForm} from '../../model';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useParams} from 'react-router';
import {AdminModel} from '../../../../entities';
interface EditAdminModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  admin?: AdminModel;
}

export const EditAdminModal = ({open, setOpen, admin}: EditAdminModalProps) => {
  const params = useParams();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Администратор',
    title: 'Ошибка при редактировании администратора',
  });

  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditAdminForm({setOpen, adminId: params.id ?? '', admin});

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактирование'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Display name"
          placeholder="Имя"
          name="displayName"
          value={values.displayName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.displayName && errors.displayName}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
